var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-message-content" },
    [
      _vm._l(_vm.processedContent, function(part, index) {
        return _c(
          "div",
          { key: index },
          [
            part.type === "product"
              ? _c("ChatProductCard", {
                  attrs: { product: part.product },
                  on: { "view-product": _vm.handleViewProduct }
                })
              : part.type === "instagram-marketing-story"
              ? _c("ChatImagePreview", {
                  attrs: {
                    image: part.post.completed_story_url,
                    title: part.post.product_title
                  },
                  on: { "view-image": _vm.handleViewImage }
                })
              : part.type === "instagram-main-feed-post"
              ? _c("ChatMainFeedPost", {
                  attrs: { post: part.post },
                  on: {
                    "copy-success": _vm.handleCopySuccess,
                    "copy-error": _vm.handleCopyError
                  }
                })
              : part.type === "text"
              ? _c("div", {
                  staticClass: "message-text",
                  domProps: { innerHTML: _vm._s(part.content) }
                })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.message.attachments && _vm.message.attachments.length > 0
        ? _c("MessageAttachments", {
            attrs: { attachments: _vm.message.attachments },
            on: { "preview-image": _vm.handlePreviewAttachmentImage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }